import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onClick"]

import useFileApi from 'SharedDir/common/composables/useFileApi';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import Attachment from 'SharedDir/service/file/uploader';
import { computed, ref } from 'vue';

/**
 * Компонента отвечающая за отображение вложений сообщений чата
 * в зависимости от того все ли вложения - изображения
 * должно выводить красивый коллаж, должно!!!, но пока не реализовано
 */

export default /*@__PURE__*/_defineComponent({
  ...{ name: 'MessageAttachments' },
  __name: 'MessageAttachments',
  props: {
    modelValue: {},
    readonly: { type: Boolean, default: false },
    noGallery: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const props = __props;
const emits = __emit;
const { innerValue, emitValue } = useValue(props, emits);
const { downloadFile } = useFileApi();

const currentImage = ref(0);

const isImageGallery = computed(() =>
  innerValue.value.reduce((total: boolean, { isImage }) => total && isImage, true)
);

function removeAttachment(index: number) {
  innerValue.value.splice(index, 1);
  emitValue();
}


return (_ctx: any,_cache: any) => {
  const _component_s_img = _resolveComponent("s-img")!
  const _component_s_icon = _resolveComponent("s-icon")!
  const _component_q_carousel_slide = _resolveComponent("q-carousel-slide")!
  const _component_q_carousel = _resolveComponent("q-carousel")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (isImageGallery.value && !_ctx.noGallery && _unref(innerValue).length > 0)
    ? (_openBlock(), _createBlock(_component_q_carousel, {
        key: 0,
        modelValue: currentImage.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentImage).value = $event)),
        animated: "",
        arrows: "",
        navigation: "",
        infinite: "",
        "control-color": "brand",
        padding: false
      }, _createSlots({
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(innerValue), (image, index) => {
            return (_openBlock(), _createBlock(_component_q_carousel_slide, {
              key: index,
              class: "no-padding",
              name: index
            }, {
              default: _withCtx(() => [
                _createVNode(_component_s_img, {
                  ratio: 7 / 5,
                  src: image.id
                }, null, 8, ["src"]),
                (!_ctx.readonly)
                  ? (_openBlock(), _createBlock(_component_s_icon, {
                      key: 0,
                      class: "remove-icon",
                      size: "large",
                      color: "white",
                      name: "las la-trash-alt",
                      tooltip: "Удалить вложение",
                      onClick: ($event: any) => (removeAttachment(index))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_s_icon, {
                  class: "download-icon",
                  size: "large",
                  color: "white",
                  name: "las la-cloud-download-alt",
                  tooltip: "Скачать вложение",
                  onClick: ($event: any) => (_unref(downloadFile)(image.id))
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1032, ["name"]))
          }), 128))
        ]),
        _: 2
      }, [
        (_unref(innerValue).length === 1)
          ? {
              name: "control",
              fn: _withCtx(() => []),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue"]))
    : (_openBlock(), _createBlock(_component_q_list, {
        key: 1,
        dense: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(innerValue), (image, index) => {
            return (_openBlock(), _createBlock(_component_q_item, {
              key: index,
              class: "no-padding"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_label, { class: "row items-center" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "s-link",
                      onClick: ($event: any) => (_unref(downloadFile)(image.id))
                    }, _toDisplayString(image.name), 9, _hoisted_1),
                    (!_ctx.readonly)
                      ? (_openBlock(), _createBlock(_component_s_icon, {
                          key: 0,
                          size: "small",
                          color: "brand-danger",
                          name: "las la-trash-alt",
                          tooltip: "Удалить вложение",
                          onClick: ($event: any) => (removeAttachment(index))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }))
}
}

})